import styled from '@emotion/styled';
import { mq } from '@styles/helpers';
import { Devices } from '@styles/tokens';

export const RewardContainer = styled.div<{col: number}>`
  position: relative;
  display: grid;
  grid-template-columns: repeat(${({ col }) => col}, 1fr);
  grid-gap: 20px 30px;
  justify-content: space-between;
  overflow-y: auto;
`;


export const TopContainer = styled.div`
  display:flex;
  padding-bottom: 20px;
  align-items: center;
`;

export const Title = styled.span`
  font-size: 24px;
  font-weight: 600;

  ${mq(Devices.mobile)} {
    font-size: 5vw;
  }
`;

export const NavButton = styled.button`
  margin-left: auto;
  font-size: 16px;
  font-weight: 400;
  background: ${props => props.theme.colors.placeholderColor};
  color: #fff;
  padding:8px 16px;
  border-radius:4px;
  transition: all 0.2s ease-in-out;

  &:hover{
    opacity: 0.9;
  }
`;